<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/partners",
		    "name": "Partners"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ul class="breadcrumbsul">
          <li><a href="#">Home</a></li>
          <li>></li>
          <li>Partners</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading">{{subheading}}</h2>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Introduction -->

<!-- Banner For Mobile -->

<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="mt-50">
          <!-- header background -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
  <div class="row">
    <div class="col-12">
      <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
        <h1 id="bnr-heading">{{heading}}</h1>
        <h2 id="bnr-subheading">{{subheading}}</h2>
      </div>
    </div>
  </div>
</div>

<!-- Start Agency Benefits Area -->

<div class="section-agency-benefit section-pb-60">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-12">
        <div class="section-title text-center">
          <h2 class="sectionheading">Partners</h2>
        </div>
      </div>
      <!-- <div class="col-lg-12 col-12 text-center">
        <ngx-slick-carousel class="carousel col-md-12 partner-carousel" #slickModal="slick-carousel"
          [config]="slide1Config" (init)="slick1Init()" (breakpoint)="breakpoint1()" (afterChange)="afterChange1()"
          (beforeChange)="beforeChange1()">
          <div ngxSlickItem *ngFor="let slide of slides1;let i = index" class="slide technologypartnerimg mx-2">
            <img src="{{ slide.img }}" alt="slide" class="carouselimg" id="partnerIMG{{i}}">
          </div>
        </ngx-slick-carousel>
      </div> -->
    </div>
    <ul class="row mt-30 prestigiouscustul">

      <li><img class="img-fluid" src="assets/images/partners/network.webp" alt="network"></li>
      <li><img class="img-fluid" src="assets/images/partners/NanjgelHiResTrans.webp" alt="NanjgelHiResTrans"></li>
      <li><img class="img-fluid" src="assets/images/partners/Orbit.webp" alt="Orbit"></li>
      <li><img class="img-fluid" src="assets/images/partners/MindGate.webp" alt="MindGate"></li>
      <li><img class="img-fluid" src="assets/images/partners/insight.webp" alt="insight"></li>
      <li><img class="img-fluid" src="assets/images/partners/sisl.webp" alt="sisl"></li>
      <li><img class="img-fluid" src="assets/images/partners/aws.webp" alt="aws"></li>
      <li><img class="img-fluid" src="assets/images/partners/wysetek.webp" alt="wysetek"></li>
      <li><img class="img-fluid" src="assets/images/partners/softcell.webp" alt="softcell"></li>
      <li><img class="img-fluid" src="assets/images/partners/raksha.webp" alt="raksha"></li>
      <li><img class="img-fluid" src="assets/images/partners/sarc.webp" alt="sarc"></li>
      <li><img class="img-fluid" src="assets/images/partners/digital_track.webp" alt="digital_track"></li>
      <li><img class="img-fluid" src="assets/images/partners/inspirisys.webp" alt="inspirisys"></li>
    </ul>
  </div>
</div>

<!--
<div class="section-pb-60 bgcolor">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-12">
        <div class="section-title text-center">
          <h2 class="sectionheading">Distributors</h2>
        </div>
      </div>
      <div class="col-lg-12 col-12 text-center">
        <img src="../../../assets/images/partners/beetel.webp" alt="beetel" class="carouselimg" [style.width]="partnerImgWidth">
      </div>
    </div>
  </div>
</div>
-->
<!-- End Agency Benefits Area -->

<!-- <div class="section-agency-benefit section-pt section-pb-60">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="agency-thumb mt-40">
          <div class="thumb">
            <img src="assets/images/partners/aws.webp" alt="Amazon Web Services" style="max-width: 50%;">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <p>Amazon Web Services offers a broad set of global compute, storage, database, analytics, application and deployment services that help organizations move faster, lower IT costs and scale applications.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->